import { WordPdfContentComponent } from './../word-pdf-content/word-pdf-content.component';
import { PdfImageContentComponent } from './../pdf-image-content/pdf-image-content.component';
import { ExcePdfContentComponent } from './../exce-pdf-content/exce-pdf-content.component';
import { ImagePdfContentComponent } from './../image-pdf-content/image-pdf-content.component';
import { WordPngContentComponent } from './../word-png-content/word-png-content.component';
import { PdfExcelContentComponent } from './../pdf-excel-content/pdf-excel-content.component';
import { WatermarkPdfContentComponent } from './../watermark-pdf-content/watermark-pdf-content.component';
import { ProtectPdfContentComponent } from './../protect-pdf-content/protect-pdf-content.component';
import { UnlockPdfContentComponent } from './../unlock-pdf-content/unlock-pdf-content.component';
import { SplitContentComponent } from './../split-content/split-content.component';
import { OcrPdfContentComponent } from "../ocr-pdf-content/ocr-pdf-content.component";
import { CompressPdContentComponent } from "../compress-pd-content/compress-pd-content.component";
import { PptxPdfContentComponent } from "../pptx-pdf-content/pptx-pdf-content.component";
import { Component, ViewChild, Output, EventEmitter, Input, OnInit,ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { DocumentUploadControlComponent } from './../document-upload-control/document-upload-control.component';
import { ConvertButtonComponent } from './../convert-button/convert-button.component';
import { DownloadButtonComponent } from './../download-button/download-button.component';
import { LoaderComponent } from './../loader/loader.component';
import { CommonModule } from '@angular/common';
import { IconSelectorComponent } from './../icon-selector/icon-selector.component';
import { PdfAreaSelectorComponent } from './../pdf-area-selector/pdf-area-selector.component'; // Directly import the standalone component
import { FileUploadService } from './../file-upload.service';
import * as pdfjsLib from 'pdfjs-dist/legacy/build/pdf.mjs'; // Use legacy build
import { GlobalWorkerOptions, PDFPageProxy, PDFDocumentProxy } from 'pdfjs-dist/legacy/build/pdf.mjs'; // Correct import
import { FiledraganddropComponent } from './../filedraganddrop/filedraganddrop.component';
import { ShowreviewComponent } from './../showreview/showreview.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { MergePdfContentComponent } from "../merge-pdf-content/merge-pdf-content.component";
import {PdfWordContentComponent} from "../pdf-word-content/pdf-word-content.component";

import {HtmlImageContentComponent} from "../html-image-content/html-image-content.component";

import {HtmlPdfContentComponent} from "../html-pdf-content/html-pdf-content.component";


export interface Review {
  // id?: number;
  userName: string;
  content: string;
  Page:string;
  rating: number;
  // createdAt?: Date;
}

@Component({
    selector: 'app-document-upload',
    templateUrl: './document-upload.component.html',
    styleUrls: ['./document-upload.component.css'],
    imports: [
    DocumentUploadControlComponent,
    ConvertButtonComponent,
    DownloadButtonComponent,
    LoaderComponent,
    CommonModule,
    IconSelectorComponent,
    FiledraganddropComponent,
    PdfAreaSelectorComponent, FormsModule, ShowreviewComponent // Import the standalone component here
    ,
    MergePdfContentComponent,
    SplitContentComponent,
    PdfWordContentComponent,
    HtmlImageContentComponent,
    HtmlPdfContentComponent,
    UnlockPdfContentComponent,
    ProtectPdfContentComponent,
    WatermarkPdfContentComponent,
    PdfExcelContentComponent,
    WordPngContentComponent,
    PdfImageContentComponent,
    ExcePdfContentComponent,
    ImagePdfContentComponent,
    WordPdfContentComponent,
    OcrPdfContentComponent,
    CompressPdContentComponent,
    PptxPdfContentComponent
]
})
export class DocumentUploadComponent  {
  file: File | null = null;
  watermarkfile: File | null = null;
  files: File[] = [];
  files1: File[] = [];
  files2: File[] = [];
  webUrl: string | null = null;
  isLoading = false;
  fileUploaded = false;
  convertedBlob: Blob | null = null;
  fileSelected = false;
  selectedEndpoint: string | null = null;
  showFileUpload = false;
  isPdf: boolean = false;
  isPdftoword: boolean = false;
  selectedHeader: string = '';
  selectedSubHeader: string = '';
  selectedButtonName: string = '';
  cselectedHeader: string = '';
  cselectedButtonName: string = '';
  selectedfileType:string="";
  errorMessage: string | null = null; // To store error message
  visible: boolean = false;
  htmltoimageButton=false;
  htmltopdfButton=false;
  selectedFileExtention:string="";
  HtmltoPdfRequest='';
  HtmltoImageRequest='';
  IsUrl:boolean=false;
   isConvertClicked = false;
   isSideToolBar=false;
   selectedDownloadHeader: string = '';
   selectedDownloadButton: string = '';
   selectedIconIdentifireRequest: string = '';
   receivedData: string = '';
   isDownload:boolean=true;
   subSubHeater:string="";
   IsWebUrl:boolean=false;
   IsPassword:boolean=false;
   IsError:boolean=false;
   inputText:string="";
   IsSplit:boolean=false;
   IsSplitDefaultMode:boolean=true;
   IsSplitExtractMode:boolean=false;
   IsSplitIntervalMode:boolean=false;
   splitFrom: string = '';
   splitTo: string = '';
   splitAfter: string = '';
   activeMode: string = 'default';
   pcount: number = 0;
   IsWatermark:boolean=false;
   Ishtmltoimage:boolean=false;
   Ishtmltopdf:boolean=false;
   waterMarkText:string="";
   waterMarkPosition:string="";
   waterMarkImageFile: File | null = null;
   maxFileSizeInKB = 150; // Maximum file size allowed (150 KB)
   IsTextTab:boolean=true;
   IsImageTab:boolean=false;
   isPasswordVisible: boolean = false;  // To track visibility of password
   isWordtoPng: boolean = false;
   isMobile: boolean = false;
   sortAsc = false;
   sortIconAnimate = false;
   showPdfSelector: boolean = true;
     IsUnlock:boolean=false;
   IsProtectPdf:boolean=false;
   IsPdfToExcel:boolean=false;
   IsWordtoPng:boolean=false;
   IsImagetoPdf:boolean=false;
   IsExceltoPdf:boolean=false;
   IsPdftoImage:boolean=false;
  IsWordtoPdf:boolean=false;
  isOcr:boolean=false;
  isCompress:boolean=false;
  isPptx:boolean=false;
   
  @ViewChild(ConvertButtonComponent) convertButton!: ConvertButtonComponent;
  @ViewChild(PdfAreaSelectorComponent) pdfSelector!: PdfAreaSelectorComponent;
  @Output() idetifiredataEmitter: EventEmitter<string> = new EventEmitter<string>();
  @Output() DIconselected: EventEmitter<string> = new EventEmitter<string>();
  @Input() cIsWeblink!:boolean;
  @Input() Review = [];
  fileData: { files: File[]; pageOrders: number[][] } | null = null; // Holds the updated file and page order data
  constructor(private http: HttpClient,private fileUploadService: FileUploadService,private cdr: ChangeDetectorRef,private breakpointObserver: BreakpointObserver) {
    this.breakpointObserver.observe([Breakpoints.Handset]).subscribe(result => {
      this.isMobile = result.matches;
    });
  }
  togglePasswordVisibility(): void {
    this.isPasswordVisible = !this.isPasswordVisible;
  }
  positions = [
    { id: 'top-left', name: 'Top Left', x: 70, y: 700 },
    { id: 'top-center', name: 'Top Center', x: 300, y: 700 },
    { id: 'top-right', name: 'Top Right', x: 560, y: 700 },
    { id: 'middle-left', name: 'Middle Left', x: 70, y: 400 },
    { id: 'middle-center', name: 'Middle Center', x: 300, y: 400 },
    { id: 'middle-right', name: 'Middle Right', x: 560, y: 400 },
    { id: 'bottom-left', name: 'Bottom Left', x: 70, y: 80 },
    { id: 'bottom-center', name: 'Bottom Center', x: 300, y: 80 },
    { id: 'bottom-right', name: 'Bottom Right', x: 560, y: 80 }
  ];
  selectedPosition: string = this.positions[0].id; // Default selected position
  getPositionCoordinates(id: string) {
    return this.positions.find(position => position.id === id);
  }
  toggleSort(): void {
    this.sortIconAnimate = true;
    this.sortAsc = !this.sortAsc;
  
    const naturalCompare = (a: string, b: string): number => {
      return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
    };
  
    const sorted = [...this.files].sort((a, b) => {
      const nameA = a.name.toLowerCase();
      const nameB = b.name.toLowerCase();
      return this.sortAsc ? naturalCompare(nameA, nameB) : naturalCompare(nameB, nameA);
    });
  
    
  
    this.files = sorted;
    this.files1 = [...sorted];
  
    this.showPdfSelector = false;
    this.cdr.detectChanges(); // Trigger update
    setTimeout(() => {
      this.showPdfSelector = true;
    });
  }
  
  
  
  
  
  
  handleErrorMessage(errormsg:string)
  {
    this.errorMessage=errormsg;
    this.visible = true;
    setTimeout(() => {
      this.visible = false;
    }, 3000);
  }
  // ngOnInit(): void {
  //   this.fileUploadService.currentErrorMessage.subscribe(IsError => this.IsError = IsError);
  //   if(this.IsError)
  //   {
  //      this.errorMessage = 'Only a single file is allowed.';
  //           this.visible = true;
  //           setTimeout(() => {
  //             this.visible = false;
  //           }, 3000);
  //   }
  // }
  onWaterMarkFileSelected(event: any): void {
    const file = event.target.files;
      this.watermarkfile=file[0];
    if (!file[0].type.startsWith('image/')) {
      this.errorMessage = 'Please chose a valid image file.';
      event.target.value = ''; // Clear the file input
      this.visible=true;
      setTimeout(() => {
        this.visible = false;
         }, 2000); // 10 seconds
      event.target.value = ''; 
      return;
    }

    

    const fileSizeInKB = file[0].size / (1024); // Convert file size to MB

    if (fileSizeInKB > this.maxFileSizeInKB) {
      this.errorMessage = `File size exceeds the allowed limit of ${this.maxFileSizeInKB} MB. Please upload a smaller file.`;
      // Clear the file input value to reset
      this.visible=true;
      setTimeout(() => {
        this.visible = false;
         }, 2000); // 10 seconds
      event.target.value = ''; 
    } else {
      this.errorMessage = null; // Clear error if file size is valid
      // Proceed with file processing
     
    }
  }

  onTabClick(tabId: string) {

    if(tabId=="text")
    {
      this.IsTextTab=true;
      this.IsImageTab=false;
    }
    else if(tabId=="image")
      {
        this.IsImageTab=true;
        this.IsTextTab=false;
      }
   
    // You can implement any specific behavior here based on the clicked tab
  }

  receiveData(data: string) {
    this.isDownload = false;
     this.receivedData = data;
    this.idetifiredataEmitter.emit(this.receivedData);
  }
  downloadIconSelected(data: string) {
    this.isDownload = false;
    this.DIconselected.emit(data);
  }

  onIconSelected(url: string): void {
    this.selectedEndpoint = url;
    this.showFileUpload = true;
    this.fileSelected = true;
    this.fileUploaded=false;
    this.isDownload=false;
    
    this.fileUploadService.currentHeader.subscribe(selectedHeader => this.selectedHeader = selectedHeader);
    this.fileUploadService.currentSubHeader.subscribe(selectedSubHeader => this.selectedSubHeader = selectedSubHeader);
    this.fileUploadService.currentButtonName.subscribe(selectedButtonName => this.selectedButtonName = selectedButtonName);
    this.fileUploadService.ccurrentHeader.subscribe(cselectedHeader => this.cselectedHeader = cselectedHeader);
    this.fileUploadService.ccurrentButtonName.subscribe(cselectedButtonName => this.cselectedButtonName = cselectedButtonName);
    this.fileUploadService.currentFileType.subscribe(selectedfileType => this.selectedfileType = selectedfileType);
    this.fileUploadService.currentHtmltoPdf.subscribe(HtmltoPdfRequest => this.HtmltoPdfRequest = HtmltoPdfRequest);
    this.fileUploadService.currentHtmltoImage.subscribe(HtmltoImageRequest => this.HtmltoImageRequest = HtmltoImageRequest);
    this.fileUploadService.currentDownloadHeaders.subscribe(selectedDownloadHeader => this.selectedDownloadHeader = selectedDownloadHeader);
    this.fileUploadService.currentDownloadButton.subscribe(selectedDownloadButton => this.selectedDownloadButton = selectedDownloadButton);
    this.fileUploadService.currenticonIdentifierRequest.subscribe(selectedIconIdentifireRequest => this.selectedIconIdentifireRequest = selectedIconIdentifireRequest);
    this.fileUploadService.currentsubSubHeader.subscribe(subSubHeater => this.subSubHeater = subSubHeater);

   if (this.selectedIconIdentifireRequest=='compress') {
     
      this.isCompress=true;
    }
    else
    {
      this.isCompress=false;
    }
    if (this.selectedIconIdentifireRequest=='ocr') {
     
      this.isOcr=true;
    }
    else
    {
      this.isOcr=false;
    }
    if (this.selectedIconIdentifireRequest=='pptxtopdf') {
     
      this.isPptx=true;
    }
    else
    {
      this.isPptx=false;
    }
       if (this.selectedIconIdentifireRequest=='wordtopdf') {
     
      this.IsWordtoPdf=true;
    }
    else
    {
      this.IsWordtoPdf=false;
    }
     if (this.selectedIconIdentifireRequest=='pdftoimage') {
     
      this.IsPdftoImage=true;
    }
    else
    {
      this.IsPdftoImage=false;
    }
     if (this.selectedIconIdentifireRequest=='imagetopdf') {
     
      this.IsImagetoPdf=true;
    }
    else
    {
      this.IsImagetoPdf=false;
    }
 if (this.selectedIconIdentifireRequest=='exceltopdf') {
     
      this.IsExceltoPdf=true;
    }
    else
    {
      this.IsExceltoPdf=false;
    }

 if (this.selectedIconIdentifireRequest=='wordtopng') {
     
      this.IsWordtoPng=true;
    }
    else
    {
      this.IsWordtoPng=false;
    }
 if (this.selectedIconIdentifireRequest=='pdftoexcel') {
     
      this.IsPdfToExcel=true;
    }
    else
    {
      this.IsPdfToExcel=false;
    }
    if (this.selectedIconIdentifireRequest=='protect') {
     
      this.IsProtectPdf=true;
    }
    else
    {
      this.IsProtectPdf=false;
    }

    if (this.selectedIconIdentifireRequest=='unlock') {
     
      this.IsUnlock=true;
    }
    else
    {
      this.IsUnlock=false;
    }

    if (this.selectedIconIdentifireRequest=='htmltoimage') {
     
      this.Ishtmltoimage=true;
    }
    else
    {
      this.Ishtmltoimage=false;
    }
     if (this.selectedIconIdentifireRequest=='htmltopdf') {
     
      this.Ishtmltopdf=true;
    }
    else
    {
      this.Ishtmltopdf=false;
    }
if (this.selectedIconIdentifireRequest=='pdftoword') {
     
      this.isPdftoword=true;
    }
    else
    {
      this.isPdftoword=false;
    }
    if (this.selectedIconIdentifireRequest=='wordtopng') {
     
      this.isWordtoPng=true;
    }
    else
    {
      this.isWordtoPng=false;
    }
    if (this.selectedIconIdentifireRequest=='htmltoimage' || this.selectedIconIdentifireRequest=='htmltopdf') {
     
      this.cIsWeblink=true;
    }
    else
    {
      this.cIsWeblink=false;
    }
   
    if(this.selectedIconIdentifireRequest=="protect" || this.selectedIconIdentifireRequest=="unlock")
    {
      this.IsWebUrl=false;
      this.IsPassword=true;
    }
    else
    {
      this.IsPassword=false;
    }
    if(this.selectedIconIdentifireRequest=="split")
      {
        this.IsSplit=true;
      
      }
      else
      {
        this.IsSplit=false;
      }
      if(this.selectedIconIdentifireRequest=="watermark")
        {
          this.IsWatermark=true;
        
        }
        else
        {
          this.IsWatermark=false;
        }
    if (this.selectedfileType=='pdf') {
      this.selectedFileExtention=".pdf";
    }
    else if (this.selectedfileType=='image') {
      
        this.selectedFileExtention=".png,.jpg,.webp,.svg";
      }
      else if (this.selectedfileType=='word') {
        
          this.selectedFileExtention=".docx,.doc,.dot,.dotx,.docm,.dotm"
        }
        else if (this.selectedfileType=='excel') {
        
          this.selectedFileExtention=".xlsx,.xls"
        }
        else if (this.selectedfileType=='pdf_image') {
        
          this.selectedFileExtention=".png,.jpg,.pdf"
        }
        else if (this.selectedfileType=='pptx') {
        
          this.selectedFileExtention=".pptx,.ppt,.ppsx,.pps"
        }
        
  }

// Method to open the URL modal
openUrlModal() {
  $('#urlModal').modal('show');
  // Use jQuery or native JS to open the modal
}

splittoggleDiv(mode: string){
  this.activeMode = mode;
if(mode=="default")
{
  this.IsSplitDefaultMode=true;
  this.IsSplitExtractMode=false;
  this.IsSplitIntervalMode=false;
}
else if(mode=="extract")
  {
    this.IsSplitDefaultMode=false;
    this.IsSplitExtractMode=true;
    this.IsSplitIntervalMode=false;
  }
  else if(mode=="interval")
    {
      this.IsSplitDefaultMode=false;
      this.IsSplitExtractMode=false;
      this.IsSplitIntervalMode=true;
    }
}
onManualFileSelected(event: Event): void {
  const inputElement = event.target as HTMLInputElement;
  if (!inputElement.files || inputElement.files.length === 0) return;
  this.files2=[];
  const selectedFiles = Array.from(inputElement.files);

  // Ensure only new files are added
  this.files2 = [...this.files2, ...selectedFiles];

 

  // Notify child component
  //this.onUpdatedFiles.emit(this.files1);
}

  onFileSelected(files: FileList): void {
   
    const selectedFile = files;
   

    if (selectedFile && selectedFile.length > 0) {
      this.isConvertClicked=false;
       this.isSideToolBar=false;
      this.file = selectedFile[0];
      this.errorMessage = null; // Reset error message

      if (this.selectedIconIdentifireRequest=="merge" || this.selectedIconIdentifireRequest=="imagetopdf") {
        this.files = []; // Initialize array for multiple files
        // this.files1 = selectedFile; 
        this.files1 = Array.from(selectedFile); ; 
        for (let i = 0; i < selectedFile.length; i++) {
          const file = selectedFile[i];
          
          // Check file type
          if (this.isValidFileType(file)) {
            this.files.push(file); // Add valid file to the list
          } else {
            this.files = [];
            this.fileUploaded = false;
            this.errorMessage = 'Invalid file type selected. Please choose the correct file type.';
            this.visible = true;
            setTimeout(() => {
              this.visible = false;
            }, 2000);
            return; // Exit function on invalid file type
          }
        }
        this.fileUploaded = true;
        this.showFileUpload = false;
        this.isPdf = this.files.every(file => file.type === 'application/pdf'); // 
      }
      // else if(selectedFile.length == 1 && this.selectedIconIdentifireRequest=="merge")
      // {
      //       this.files = [];
      //       this.fileUploaded = false;
      //       this.errorMessage = 'select more than one pdf file for merge.';
      //       this.visible = true;
      //       setTimeout(() => {
      //         this.visible = false;
      //       }, 2500);
      //       return;
      // }
      else{
        // const selectedFile = event.target.files[0];
         this.file = selectedFile[0];
         this.fileUploaded = true;
         this.isConvertClicked=false;
       
        //  this.isLoading=false;
        //  this.convertedBlob=new Blob();
        //  this.isSideToolBar=false;
          this.showFileUpload = true;
       //  this.isPdf = this.files.every(file => file.type === 'application/pdf'); // 
         

      // Check file type based on selected endpoint or icon
      if (this.isValidFileType(selectedFile[0])) {
        this.fileUploaded = true;
        this.showFileUpload = false;
        this.isPdf = selectedFile[0].type === 'application/pdf';
      } else {
        this.file = null;
        this.fileUploaded = false;
        this.errorMessage = 'Invalid file type selected. Please choose the correct file type.';
        this.visible = true;

        setTimeout(() => {
          this.visible = false;
        }, 2000);
      }

      }
    
    }

  }
  
  async getPdfPageCount(file: File): Promise<number> {
    const fileReader = new FileReader();
  
    return new Promise((resolve, reject) => {
      fileReader.onload = async (event: any) => {
        try {
          const typedArray = new Uint8Array(event.target.result);
          
          // Make sure the worker is properly initialized
          pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.9.359/pdf.worker.min.js';
          
          // Load the PDF document
          const pdfDocument: PDFDocumentProxy = await pdfjsLib.getDocument(typedArray).promise;
          
          // Ensure numPages is correct
          if (pdfDocument.numPages > 0) {
            this.pcount = pdfDocument.numPages;
           
            resolve(pdfDocument.numPages);
          } else {
            reject(new Error('PDF has zero pages.'));
          }
        } catch (error) {
          reject(error);
        }
      };
  
      // Error handling for FileReader
      fileReader.onerror = () => {
        reject(new Error("Error reading file."));
      };
  
      // Read the file as an ArrayBuffer
      fileReader.readAsArrayBuffer(file);
    });
  }
  
  

  // async getPdfPageCount(file: File): Promise<number> {
  //   const fileReader = new FileReader();
  //   return new Promise((resolve, reject) => {
  //     fileReader.onload = async (event: any) => {
  //       const typedArray = new Uint8Array(event.target.result);
  //       try {
  //         const pdfDocument: PDFDocumentProxy = await pdfjsLib.getDocument(typedArray).promise;
  //         this.pcount=pdfDocument.numPages;
  //         resolve(pdfDocument.numPages);  // Number of pages in the PDF
  //       } catch (error) {
  //         reject(error);
  //       }
  //     };
  //     fileReader.readAsArrayBuffer(file);
  //   });
  // }
  

  isValidUrl(url: string): boolean {
    try {
      new URL(url); // Throws error if URL is invalid
      return true;
    } catch (_) {
      return false;
    }
  }

  addUrl(url:string):void
  {
    this.inputText=url;
    this.IsWebUrl=true;
    if(this.selectedIconIdentifireRequest=="htmltoimage" || this.selectedIconIdentifireRequest=="htmltopdf")
    {
    const blob = new Blob(["This is a dummy file content"], { type: "application/image" });
    this.file = new File([blob], "web.png", { type: "application/image"  });
    }
    // else  if(this.selectedIconIdentifireRequest=="htmltopdf")
    //   {
    //   const blob = new Blob(["This is a dummy file content"], { type: "application/pdf" });
    //   this.file = new File([blob], "dummy.pdf", { type: "application/pdf"  });
    //   }
    
   
    if (url?.trim() && this.isValidUrl(url)) {
      this.webUrl=url;
      this.isConvertClicked=false;
      this.isSideToolBar=false;
    
      this.errorMessage = null; // Reset error message
      this.errorMessage =  this.cselectedHeader; // Reset error message

      // Check file type based on selected endpoint or icon
      
        this.fileUploaded = true;
        this.showFileUpload = false;
        this.isPdf =false;
        this.isLoading=false;
       
        //  this.file = true;
        
        this.errorMessage = 'Wite the Url.';
        this.visible = false;
        $('#urlModal').modal('hide');
      
    }
    else{
      this.visible = true;
      if(url=='')
      {
        this.errorMessage="Enter web link";
      }
      else{
      this.errorMessage="Invalid URL.";
      }
      setTimeout(() => {
        this.visible = false;
         }, 2000); // 10 seconds
    }
  }
  
  isValidFileType(file: File): boolean {
    if (!this.selectedEndpoint) return false;

    if (this.selectedfileType=='pdf') {
      return file.type === 'application/pdf';
    } else if (this.selectedfileType=='image') {
      return file.type.startsWith('image/');
    } else if (this.selectedfileType=='word') {
      return file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    }else if (this.selectedfileType=='pptx') {
      if(file.type=='application/vnd.openxmlformats-officedocument.presentationml.presentation')
      return file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
     else if (file.type=='application/vnd.ms-powerpoint')
      return file.type === 'application/vnd.ms-powerpoint';
    }
    else if (this.selectedfileType=='pdf_image') {
      let ocr = this.selectedfileType.split("_");
      if (ocr[0]=='pdf' && file.type === "application/pdf") {
        return file.type === 'application/pdf';
      } else if (ocr[1]=='image' && file.type.startsWith("image")) {
        return file.type.startsWith('image/');
      }
      }
    else if (this.selectedfileType=='excel') {
      return file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }
    return false;
  }

  onConvert(): void {

if(this.selectedIconIdentifireRequest=="split")
      {
       
        this.fileUploadService.currentnumberofPdfPages.subscribe(pcount => this.pcount = pcount);
        if(this.pcount==1)
          {
        this.visible = true;
        this.errorMessage="Pdf file should have more than one page to split!";
        setTimeout(() => {
          this.visible = false;
           }, 2000); // 10 seconds
           return;
       }
      }

    if(this.IsPassword)
    {
      if(this.inputText=='' || this.inputText==null)
      {
        this.visible = true;
        this.errorMessage="Write Password";
        setTimeout(() => {
          this.visible = false;
           }, 2000); // 10 seconds
           return;
      }
    }

    if(this.IsWatermark)
      {
        if(this.IsTextTab)
        {
        if(this.waterMarkText=='' || this.waterMarkText==null)
        {
          this.visible = true;
          this.errorMessage="Write Watermark Text";
          setTimeout(() => {
            this.visible = false;
             }, 2000); // 10 seconds
             return;
        }
      }
      else if(this.IsImageTab)
      {
        if (!this.watermarkfile) 
          {
          this.visible = true;
          this.errorMessage="Pick Watermark Image";
          setTimeout(() => {
            this.visible = false;
             }, 2000); // 10 seconds
            return;
          }
      }
      }
    
    if (!this.file || !this.selectedEndpoint) return;
    this.showFileUpload = false;
    this.isSideToolBar=true;
     this.isConvertClicked = true;
     this.isDownload=true;
     //this.fileUploaded = false;
    this.isPdf =false;
    this.isLoading = true;

    const formData = new FormData();
    if (this.webUrl !== null && this.webUrl !== undefined && this.webUrl !== '')
    // if(this.webUrl!="")
    {
      formData.append('url', this.webUrl||''); 
    }
     // Check if multiple files are selected (for "Merge PDF")
    else if (this.selectedHeader === 'Merge PDF') {
      if (Array.isArray(this.files)) {
      Array.from(this.files).forEach((file: File) => {
        formData.append('file', file); // Using the same key
      });
      if (this.fileData) {
        const pageOrdersString = this.fileData?.pageOrders.map(pages => pages.join(',')).join('|');
      formData.append('pageOrders', JSON.stringify(pageOrdersString));
      }
      else{
        formData.append('pageOrders',"");
      }
      
    }
 
  // Handle single ZIP file case for merging
  else if (this.file && this.file.type === 'application/zip') {
    formData.append('zipFile', this.file); // Add ZIP file
  } else{
    formData.append('file', new Blob());
  }
}
else if (this.selectedHeader === 'Image to PDF') {
  if ((Array.isArray(this.files) && this.files.length > 1)) {
  Array.from(this.files).forEach((file: File) => {
    formData.append('file', file); // Using the same key
  });
}
else if (this.file) {
  formData.append('file', this.file);
}
}
  else if (this.file) {
    if(this.subSubHeater=="Password"){
      formData.append('file', this.file);
      formData.append('password', this.inputText);
    }
    else{
      if(this.IsSplit)
        {
          formData.append('pdfFile', this.file); 
          formData.append('fromPage', this.splitFrom); 
          formData.append('toPage', this.splitTo); 
          formData.append('interval', this.splitAfter); 
        }
     else if(this.IsWatermark)
      {
        formData.append('PdfFile', this.file); 
        if (this.watermarkfile) {
          formData.append('ImageFile', this.watermarkfile);
         // formData.append('ImageFile', new Blob());
        } 
        else{
          formData.append('ImageFile', new Blob());
        }
        formData.append('CertFile', new Blob());
        formData.append('certPassword', "");
        const xPosition = this.getPositionCoordinates(this.selectedPosition)?.x;
        formData.append('xPosition', xPosition !== undefined ? xPosition.toString() : '');
        const yPosition = this.getPositionCoordinates(this.selectedPosition)?.y;
        formData.append('yPosition', yPosition !== undefined ? yPosition.toString() : '');
        formData.append('watermarkText', this.waterMarkText); 
      }
      else
      formData.append('file', this.file); // Single file case
    }
   
  }
    // const formData = new FormData();
    // formData.append('file', this.file);
   
  
  // OR (if you want a cleaner output)
 
  
    this.http.post(this.selectedEndpoint, formData, { responseType: 'blob' })
        .subscribe({
        next: (response: Blob) => {
          this.convertedBlob = response;
        },
        error: (error) => {
          console.error('Error converting file:', error);
        },
        complete: () => {
          this.isLoading = false;
        }
      });
  }
  
  get fileName(): string {
    return this.isPdf ? 'converted_files.zip' : 'converted_file.docx';
  }
  onUpdatedData(data: { files: File[]; pageOrders: number[][] }) {
    // Receive the updated data from the child component
    this.fileData = data;
    
  }
  onUpdatedFiles(updatedFiles: File[]) {
    this.files = updatedFiles; // Update files in parent
   // this.files = [...updatedFiles];
    
  }
  handleAllFilesRemoved() {
    this.showFileUpload=true;
    this.fileUploaded=false;
    this.files=[];
    
  }
}
